import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import BasicUserInformation from "../BasicUserInformation/BasicUserInformation";
import AddressData from "../AddressData/AddressData";
import ReviserData from "../ReviserData/ReviserData";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import NameAndAddressData from "../NameAndAddressData/NameAndAddressData";
import AddressDataShort from "../AddressDataShort/AddressDataShort";
import Row from "../WrapperComponents/Row";
import ColDynamic from "../WrapperComponents/ColDynamic";
import { validateRequiredFields } from "../../../helperFunctions/validationHelpers/validateRequiredFields";
import { Spinner } from "react-bootstrap";

export const EntryForm6 = (props) => {

  const popuniZagradu = (clan) =>{
    if(clan.ime && clan.prezime){
      return `(${clan.ime} ${clan.prezime})`;
    }else if(clan.nazDrustva){
      return `(${clan.nazDrustva})`;
    }
  return "(Novi unos)";
}

  const { reviserRegistration } = props.parentState.newFormData;

  const { address, residencyAddress } = props.parentState.newFormData;

  let { requiredFieldsAddress } = address;
  if (address.sifDrzave != "191") {
    requiredFieldsAddress = [
      "sifDrzave",
      "nazNaselja",
      "ulicaKbr",
      "permitDate",
      "permitNumber",
      "brPoste",
    ];
  }
  const validateAddress = validateRequiredFields(
    address,
    requiredFieldsAddress
  );

  let { requiredFieldsResidencyAddress } = residencyAddress;

  if (residencyAddress.sifDrzave != "191") {
    requiredFieldsResidencyAddress = [
      "sifDrzave",
      "nazNaselja",
      "ulicaKbr",
      "brPoste",
    ];
  }

  const validateResidencyAddress = validateRequiredFields(
    residencyAddress,
    requiredFieldsResidencyAddress
  );

  const mappedReviserData = reviserRegistration.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`reviser-registration-collapse${index}`}
        clickText={`Podaci o revizorskom društvu ili samostalnom revizoru kod kojeg je ovlašteni revizor zaposlen ili s kojim je povezan kao partner ili na drugi način 
        ${popuniZagradu(element)}`}
      >
        <ReviserData required id={element.id} {...props} />
        <Row>
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length - 1 === index ? 
              <ButtonComponent
               id={props.id}
               onClick={(e) =>
                 props.multiplyComponent(e, { formGroup: "reviserRegistration" })
               }
              >
               Dodaj novi
              </ButtonComponent> 
            :
              null
            }
          </ColDynamic>
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length > 1 && (
              <ButtonComponent
                variant="danger"
                id={element.id}
                onClick={(e) =>
                  props.removeComponentHandler(e, {
                    formGroup: "reviserRegistration",
                  })
                }
              >
                Ukloni
              </ButtonComponent>
            )}
          </ColDynamic>
        </Row>
      </CollapsableWrapper>
    );
  });

  const { revRegWorkLicence } = props.parentState.newFormData;
  const mappedWorkingLicenceRegistration = revRegWorkLicence.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`rev-reg-work-licence-collapse${index}`}
          clickText={`Odobrenje za rad od nadležnog tijela matične države članice ${
            revRegWorkLicence.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            brRegOrig
            disableCro
            requiredAddress
            {...props}
            datLabel="Datum odobrenja za rad"
            regLabel="Broj odobrenja za rad"
            regId="reg-rev-licence"
            id={element.id}
            idZaBtn={index}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.revRegWorkLicence}
            group="revRegWorkLicence"
          />
        </CollapsableWrapper>
      );
    }
  );

  const { revReg3rdParty } = props.parentState.newFormData;
  const mappedRevReg3rdParty = revReg3rdParty.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`rev-reg-3rd-party-collapse${index}`}
        clickText={`Registracija ovlaštenog revizora kod nadležnog tijela drugih država članica i kao revizora kod nadležnih tijela u trećim zemljama 
        ${revReg3rdParty.length > 1 ? `(${index + 1})` : ""}`}
      >
        <MappedRegistrationComponent
          {...props}
          id={element.id}
          idZaBtn={index}
          regId="rev-reg-third-p"
          onChange={props.mappedUserInputHandler}
          inputValue={props.parentState.newFormData.revReg3rdParty}
          group="revReg3rdParty"
        />
      </CollapsableWrapper>
    );
  });

  const { revRegCompetentBody } = props.parentState.newFormData;
  const mappedRegCompData = revRegCompetentBody.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`rev-reg-comp-body-collapse${index}`}
        clickText={`Nadležna tijela država članica odgovorna  za nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i revizorskih društava 
        ${revRegCompetentBody.length > 1 ? `(${index + 1})` : ""}`}
      >
        <NameAndAddressData
          group={"revRegCompetentBody"}
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText={"Osnovni podaci"}>
        <BasicUserInformation
          stranac
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt == 1
          }
          required
          {...props}
        />
      </CollapsableWrapper>

      <CollapsableWrapper
        clickText={"Podaci o adresi prebivališta i registraciji"}
      >
        <AddressData
          requiredRegistration
          requiredKbr
          requiredBrPoste={!validateResidencyAddress}
          permitDateLabel="Datum odobrenja za rad"
          permitNumberLabel="Broj odobrenja za rad"
          required={!validateResidencyAddress}
          disableDistrict={disableDistrict}
          disableCity={disableCity}
          disableCounty={disableCounty}
          {...props}
        />
      </CollapsableWrapper>
      <CollapsableWrapper clickText={"Adresa boravišta"}>
        <AddressDataShort
          required={!validateAddress}
          {...props}
          address={props.parentState.newFormData.residencyAddress}
        />
      </CollapsableWrapper>
      {mappedReviserData}
      {mappedWorkingLicenceRegistration}
      {mappedRevReg3rdParty}
      {mappedRegCompData}
      <br></br>
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </>
  );
};
